<template>
  <div>

    <form v-on:submit="saveGradeSetup">
      <div class="card card-info" v-show="screen !== 'grid'">
        <div class="card-header with-border">
          <h3 class="card-title">Grade Setups</h3>
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="row" style="margin-top: 0px;">
                <div class="col-md-5">
                  <label>Title</label>
                  <input class="form-control" v-model="gradesetup.Title" required />
                </div>
                <div class="col-md-5">
                  <label>Descrpition</label>
                  <input class="form-control" v-model="gradesetup.Description" required />
                </div>
                <div class="col-md-2">
                  <label>Active</label>
                  <select class="form-control" v-model="gradesetup.Active" required>
                    <option v-bind:value="true">True</option>
                    <option v-bind:value="false">False</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-12">
              <table class="table table-bordered table-sm">
                <thead class="bg-info">
                  <tr>
                    <th>Marks From</th>
                    <th>Marks Up To</th>
                    <th>Grade Point</th>
                    <th>Grade</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in gradesetup.GradeSetupChild">
                    <td>
                      <input class="form-control"  v-model="item.MarksFrom" v-mask="'###'" placeholder="Marks From" required />
                    </td>
                    <td>
                      <input class="form-control"  v-model="item.MarksTo" v-bind:min="item.MarksFrom" v-mask="'###'" placeholder="Marks To" required />
                    </td>
                    <td>
                      <input class="form-control" v-model="item.Points" v-mask="'#####'" maxlength="5" placeholder="Grade Points" required />
                    </td>
                    <td>
                      <input class="form-control" v-model="item.Grade" maxlength="2" required />
                    </td>
                    <td>
                      <i class="fa fa-trash fa-2x" v-on:click="remove(ind)"></i>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <button style="width: 100%" class="btn btn-info" v-on:click="addnew()" type="button">+Add New</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <hr />
        <!--Button -->
        <div class="card-footer"> 
          <button type="submit" class="btn btn-success" style="width: 120px;float:right">Save</button>
          <button class="btn btn-danger" type="button" v-on:click="changestate('grid')" style="width: 120px" type="reset">Cancel</button>
        </div> 
      </div>
    </form>
    <div class="card card-info" runat="server" v-if="screen === 'grid'">
      <div class="card-header with-border">
        <h3 class="card-title" style="width: 100%">
          <button v-on:click="changestate('edit', 'new')" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3> 
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12">
            <table class="table table-bordered table-color" id="table">
              <thead class="bg-info">
                <tr>
                  <th>Sr. No.</th>
                  <th>Title</th>
                  <th>Descreption</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in GradeSetup">
                  <td>{{ind+1}}</td>
                  <td>{{item.Title}}</td>
                  <td>{{item.Description}}</td>
                  <td>{{item.Active}}</td>
                  <td> 
                    <button class="btn btn-sm btn-primary" v-on:click="editGradeSetup(item.GradeSetupID)">Edit</button> 
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        GradeSetup: [],
        gradesetup: {
          Title: '',
          Description: '',
          Active: true,
          GradeSetupChild: [{
            MarksFrom: '',
            MarksTo: '',
            Points: '',
            Grade: '',
          }],
        },
        screen: 'grid',
      }
    },

       created: function () {
      this.pageload();
    },

    updated: function () {
      $('#table').DataTable();
    },

    methods:
    {
      pageload() {
        var vm = this;
        axios.post('/api/ExamApi/PageloadGradeSetup')
          .then(function (response) {
            vm.GradeSetup = response.data.lst;
          });
      },

      addnew() {
        this.gradesetup.GradeSetupChild.push({
          MarksFrom: '',
          MarksTo: '',
          Points: '',
          Grade: '',
        });
      },

      remove(ind) {
        this.gradesetup.GradeSetupChild.splice(ind, 1);
      },

      changestate: function (newstate, t) {
        this.screen = newstate;
        if (t == 'new') {
          this.gradesetup = {
            Title: '',
            Description: '',
            GradeSetupChild: [{
              MarksFrom: '',
              MarksTo: '',
              Points: '',
              Grade: '',
            }],
          };
        }
      },

      saveGradeSetup(e) {
        e.preventDefault();
        var vm = this;
        axios.post('/api/ExamApi/saveGradeSetup', {
          obj: vm.gradesetup,
        })
          .then(function (response) {
            if (response.data.status) {
              toastr.success('Save Successfully', 'Save');
              vm.screen = 'grid';
              vm.pageload();
            }
            else {
              toastr.error('Something went wrong', 'Error!');
            }
          })
      },

      editGradeSetup(id) {
        var vm = this;
        axios.post('/api/ExamApi/editGradeSetup?ID=' + id)
          .then(function (response) {
            vm.gradesetup = response.data.lst;
            vm.screen = 'edit';
          })
      },
    }

  })
</script>



// WEBPACK FOOTER //
// src/components/exam/GradeSetup.vue